import { CREATE_TRANSFER_CORE, CREATE_EXTERNAL_TRANSFER_CORE} from './../constants';
import { handleActions } from "redux-actions"

export const transferscore  = handleActions(
  { 
    [ CREATE_TRANSFER_CORE ]: (state, action) => {
      const {error} = action.payload
      if (error) {
        return state
      } else {
        return [...state, action.payload.data]
      }
    },
    [ CREATE_EXTERNAL_TRANSFER_CORE ]: (state, action) => {
      const {error} = action.payload
      if (error) {
        return state
      } else {
        return [...state, action.payload.data]
      }
    },
  }, []
)